import { TableCell, TableRow } from '@lokalise/louis'
import type { AiConfigLanguage } from '@lokalise/translation-api-schemas'
import clsx from 'clsx'
import { Fragment } from 'react'
import { TargetLanguagesTable } from '../TargetLanugagesTable/TargetLanguagesTable'
import styles from './TmTargetLanguagesView.module.css'

type TmTargetLanguagesViewProps = {
  highlighted?: boolean
  targetLangs?: AiConfigLanguage[]
  afterDate?: string
}

const COLUMNS = ['Target language', 'TM entries'] as [string, string]

export const TmTargetLanguagesView = ({
  highlighted = false,
  targetLangs = [],
  afterDate,
}: TmTargetLanguagesViewProps) => (
  <TargetLanguagesTable
    highlighted={highlighted}
    columns={COLUMNS}
    numberOfTargetLanguages={targetLangs.length}
  >
    {targetLangs.map(({ name, id }) => (
      <Fragment key={id}>
        <TableRow>
          <TableCell className={clsx([styles.cell, styles.cellLeft])}>{name}</TableCell>
          <TableCell className={clsx([styles.cell, styles.cellRight])} align="right">
            {afterDate ? `from ${afterDate}` : 'All TM entries'}
          </TableCell>
        </TableRow>
      </Fragment>
    ))}
  </TargetLanguagesTable>
)
